import type { TaskPriority } from "../types";

interface PriorityBadgeProps {
	priority: TaskPriority;
	size?: "sm" | "md";
}

const priorityConfig: Record<TaskPriority, { label: string; className: string }> = {
	low: {
		label: "低",
		className: "bg-slate-100 text-slate-600 border-slate-300",
	},
	medium: {
		label: "中",
		className: "bg-yellow-100 text-yellow-700 border-yellow-300",
	},
	high: {
		label: "高",
		className: "bg-red-100 text-red-700 border-red-300",
	},
};

export function PriorityBadge({ priority, size = "md" }: PriorityBadgeProps) {
	const config = priorityConfig[priority];
	const sizeClasses = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";

	return (
		<span
			className={`inline-flex items-center font-medium rounded-full border ${sizeClasses} ${config.className}`}
		>
			{config.label}
		</span>
	);
}
